import FACE_OFF_2024 from "../../images/events/face-off/face-off-2024.jpg"
import FACE_OFF_2023 from "../../images/events/face-off/faceoff-2023.jpg"
import FACE_OFF_2022 from "../../images/events/face-off/faceoff-2022.png"
import FACE_OFF_2021 from "../../images/events/face-off/faceoff-2021.png"

export const FACE_OFF = [
    {
      image: FACE_OFF_2024,
      title: "Face Off 4.0",
      description: "Face Off 4.0 by MSTC offered an exciting knockout competition, uniting coders to showcase skills, foster camaraderie, and celebrate competitive programming.",
      projects: [
        { name: "Qualifiers (1st yearites)", link: "https://www.codechef.com/FAQ22021" },
        { name: "Round-2 (1st yearites)", link: "https://www.codechef.com/FAT12021" },
        { name: "Round-3 (1st yearites)", link: "https://www.codechef.com/FOT22021" },
        { name: "Qualifiers", link: "https://www.codechef.com/FT822021" },
        { name: "Round-2", link: "https://www.codechef.com/FT422021" },
        { name: "Round-3", link: "https://www.codechef.com/FOF22021" },
        { name: "Finals", link: "https://www.codechef.com/FOF22021" },
      ],
    },
    {
      image: FACE_OFF_2023,
      title: "Face Off 3.0",
      description: "Face Off 3.0 by MSTC offered an exciting knockout competition, uniting coders to showcase skills, foster camaraderie, and celebrate competitive programming.",
      projects: [
        { name: "Qualifiers (1st yearites)", link: "https://www.codechef.com/FAQ22021" },
        { name: "Round-2 (1st yearites)", link: "https://www.codechef.com/FAT12021" },
        { name: "Round-3 (1st yearites)", link: "https://www.codechef.com/FOT22021" },
        { name: "Qualifiers", link: "https://www.codechef.com/FT822021" },
        { name: "Round-2", link: "https://www.codechef.com/FT422021" },
        { name: "Round-3", link: "https://www.codechef.com/FOF22021" },
        { name: "Finals", link: "https://www.codechef.com/FOF22021" },
      ],
    },
    {
      image: FACE_OFF_2022,
      title: "Face Off 2.0",
      description: "Face Off 2.0 by MSTC offered an exciting knockout competition, uniting coders to showcase skills, foster camaraderie, and celebrate competitive programming.",
      projects: [
        { name: "Qualifiers", link: "https://www.codechef.com/FAQ22021" },
        { name: "Round of 32", link: "https://www.codechef.com/FAT12021" },
        { name: "Round of 16", link: "https://www.codechef.com/FOT22021" },
        { name: "Round of 8", link: "https://www.codechef.com/FT822021" },
        { name: "Round of 4", link: "https://www.codechef.com/FT422021" },
        { name: "Finals", link: "https://www.codechef.com/FOF22021" },
      ],
    },
    {
      image: FACE_OFF_2021,
      title: "Face Off 1.0",
      description: "Face Off 1.0 by MSTC offered an exciting knockout competition, uniting coders to showcase skills, foster camaraderie, and celebrate competitive programming.",
      projects: [
        { name: "Qualifiers", link: "https://www.codechef.com/FAQ22021" },
        { name: "Round of 32", link: "https://www.codechef.com/FAT12021" },
        { name: "Round of 16", link: "https://www.codechef.com/FOT22021" },
        { name: "Round of 8", link: "https://www.codechef.com/FT822021" },
        { name: "Round of 4", link: "https://www.codechef.com/FT422021" },
        { name: "Finals", link: "https://www.codechef.com/FOF22021" },
      ],
    },
];
  